import { Primitive } from '../entities';

export const removePrimitiveDuplicatesFromArray = <T extends Primitive>(array: Array<T>) => {
  return Array.from(new Set(array));
};
